import { graphql, useStaticQuery } from 'gatsby';
import combinedNavigationElementMapper from '../mappers/combinedNavigationElementMapper';
import type { NavigationElement } from '../mappers/navigationElementMapper';
import navigationElementMapper from '../mappers/navigationElementMapper';

type ContentfulNode = {
    identifier: string;
};

type ContentfulNav = {
    node: ContentfulNode;
};

const useNavigation = (slug: string): NavigationElement | undefined => {
    const { allContentfulNavigationElement } = useStaticQuery(
        graphql`
            query navigationQuery {
                allContentfulNavigationElement {
                    ...ContentfulNavigation
                }
            }
        `
    );

    const rootNavigation = allContentfulNavigationElement.edges.find(
        (elem: ContentfulNav) => elem.node.identifier === 'root'
    );
    const combinedNavigationElement = combinedNavigationElementMapper(rootNavigation.node);

    return navigationElementMapper(combinedNavigationElement, slug);
};

export default useNavigation;
